<template>
  <div class="credits-logo">
    <a href="https://vut.cz/" target="_blank"><img src="../assets/vut.svg" alt="VUT"></a>
    <a href="https://unob.cz/" target="_blank"><img src="../assets/uo.svg" alt="UNOB"></a>
  </div>
</template>

<script>
export default {
  name: 'ProjectCredits',
}
</script>

<style>
.credits-logo img {
  height: 80px;
}
</style>





